var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "49px",
    viewBox: "0 0 28 49",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Gold") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 22.727 0 22.727 20.3816 0 20.3816"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Case-View",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gold"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(2.274000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.727,14.3946 L22.727,-0.0004 L0,-0.0004 L0,14.3946 L6.819,20.3796 C7.424,20.1526 8.032,20.0006 8.637,19.9246 L1.516,13.7106 L1.516,1.5156 L21.214,1.5156 L21.214,13.7126 L14.016,19.9266 C14.622,20.0786 15.229,20.1526 15.835,20.3816 L22.727,14.3946 Z",
    id: "Fill-1",
    fill: "#FEBD1A",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#DB3B57",
    points: "5.303 3.0289 5.303 13.0289 12.956 19.6969 13.637 19.6969 14.243 19.6969 21.972 13.0289 21.972 3.0289"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6375,47.4849 C6.6685,47.4849 0.9995,41.8159 0.9995,34.8479 C0.9995,30.0089 3.6635,25.6469 7.9525,23.4649 C8.8785,23.0029 9.7675,22.6819 10.6635,22.4909 C11.3245,22.3449 11.9255,22.2719 12.5345,22.2049 C12.9025,22.1339 13.3095,22.1339 13.6375,22.1339 C13.9765,22.1339 14.2955,22.1339 14.5765,22.1909 L14.7075,22.2099 C15.3585,22.2819 15.9725,22.3499 16.4985,22.4829 C17.4225,22.7469 18.3665,23.1009 19.3545,23.5569 C23.5495,25.6219 26.2745,30.0569 26.2745,34.8479 C26.2745,41.8159 20.6055,47.4849 13.6375,47.4849",
    id: "Fill-6",
    fill: "#FECE41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.637,21.1347 C13.258,21.1347 12.803,21.1347 12.424,21.2107 C11.742,21.2867 11.137,21.3637 10.455,21.5137 C9.395,21.7397 8.41,22.1187 7.5,22.5737 C3.031,24.8477 0,29.4687 0,34.8477 C0,42.3487 6.137,48.4847 13.637,48.4847 L13.637,48.4847 C21.137,48.4847 27.274,42.3487 27.274,34.8477 C27.274,29.5457 24.243,24.8477 19.774,22.6507 C18.789,22.1957 17.805,21.8167 16.742,21.5137 C16.137,21.3617 15.455,21.2867 14.774,21.2107 C14.395,21.1347 14.016,21.1347 13.637,21.1347 M13.637,23.1347 C13.937,23.1347 14.196,23.1347 14.38,23.1717 L14.51,23.1937 L14.597,23.2037 C15.2,23.2707 15.77,23.3347 16.226,23.4467 C17.118,23.7017 18.004,24.0357 18.891,24.4447 C22.769,26.3517 25.274,30.4347 25.274,34.8477 C25.274,37.9417 24.059,40.8597 21.854,43.0647 C19.649,45.2707 16.73,46.4847 13.637,46.4847 C7.22,46.4847 2,41.2647 2,34.8477 C2,30.3877 4.455,26.3677 8.395,24.3627 C9.25,23.9357 10.061,23.6427 10.887,23.4667 C11.493,23.3327 12.042,23.2657 12.646,23.1987 L12.733,23.1887 L12.818,23.1717 C13.002,23.1347 13.369,23.1347 13.637,23.1347",
    id: "Fill-8",
    fill: "#FEBD1A"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#FFB103",
    points: "13.637 26.364 15.533 32.2 21.67 32.2 16.705 35.807 18.601 41.643 13.637 38.036 8.673 41.643 10.569 35.807 5.604 32.2 11.741 32.2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold);
export default __webpack_public_path__ + "static/media/gold.c253116cd7fe1bfb644726b4d7262dd8.svg";
export { ForwardRef as ReactComponent };